export default "__VITE_ASSET__a849665c__"